export default __webpack_public_path__ + "static/media/coral-right-type-1.738330e4.gif";